<template>
  <div
    style="height:100%;background-color: rgb(153, 204, 204,0.2);padding: 14px 20px;box-sizing: border-box;"
  >
    <div style="margin:20px 0;">
      <el-date-picker
        v-model="riqi"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
        :picker-options="pickerOptions"
        style="width:160px;"
        @change="gaibianriqi($event)"
      ></el-date-picker>

      <div class="tbbutton">
        <i class="el-icon-caret-top" @click="beforetime" :class="{'active-tbbutton':sum == 1}"></i>
        <i class="el-icon-caret-bottom" @click="aftertime" :class="{'active-tbbutton':sum == 2}"></i>
      </div>
      <b style="color:#5a691a;margin-right:20px">{{nowWeek}}</b>

      <el-select
        v-model="depart_id"
        placeholder="请选择部门"
        style="width:140px;margin-left:20px;"
        @change="gaibiandepart($event)"
      >
        <el-option
          v-for="item in bumenList"
          :key="item.depart_id"
          :label="item.depart_name"
          :value="item.depart_id"
        ></el-option>
      </el-select>
      <div style="display:inline-block;float:right">
        <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
      </div>
    </div>
    <h2 align="center" style="color: #3b3b3b;margin-top:20px;">
      <span>" {{riqi}} "</span>
      <span style="color:#409eff">{{bumenname}}</span>工作安排
    </h2>
    <el-table
      :data="tableData"
      style="width: 100%"
      height="74%"
      :row-style="{height:'30'}"
      :header-cell-style="{background:'rgb(100, 168, 165)',color:'#fff'}"
      :row-class-name="tableRowClassName"
    >
      <!-- 姓名 -->
      <el-table-column align="center" label="姓名" min-width="110">
        <template slot-scope="scope">
          <div>{{ typeof scope.row.rycn == 'undefined'? scope.row.employee_id : scope.row.rycn}}</div>
        </template>
      </el-table-column>
      <!-- 项目名称 -->
      <el-table-column align="center" label="项目名称" min-width="180">
        <template slot-scope="scope">
          <div>{{ typeof scope.row.xiangmucn == 'undefined'? scope.row.project_id : scope.row.xiangmucn }}</div>
        </template>
      </el-table-column>
      <!-- 阶段任务 -->
      <el-table-column align="center" label="阶段任务" min-width="380%">
        <template slot-scope="scope">
          <div>{{scope.row.task_name_str?scope.row.task_name_str:"阶段已进行调整"}}</div>
        </template>
      </el-table-column>
      <!-- 工作时长 -->
      <el-table-column align="center" label="工作时长(H:M)" width="120%">
        <template slot-scope="scope" class="elTable">
          <div>{{scope.row.show_hour + ":" + scope.row.show_min}}</div>
        </template>
      </el-table-column>
      <!-- 工作内容 -->
      <el-table-column align="center" label="工作内容" width="400%">
        <template slot-scope="scope">
          <div>{{scope.row.comments}}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import { getBaseInfo, getPerson } from "@/api/user";
import {
  getNextDate,
  getweek,
  gettaskOptions,
  getTaskOptionValue,
  gettasklistStrName,
  hourToMin,
  myGrounpX
} from "@/lib/until";
export default {
  name: "workplan",
  data() {
    return {
      depart_id: "", //部门ID
      bumenname: "",
      bumenList: [], //部门列表
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
          return time.getTime() > date;
        }
      },
      riqi: "", //日期,
      tableData: [],
      sum: "",
      timeAndDepart: {},
      daochuData: []
    };
  },
  created() {
    this.getuserInfo();
    this.getnowtime();
    this.getTableData();
    this.getDaochu();
  },
  watch: {
    riqi(newval, oldVal) {
      this.timeAndDepart.changeTime = newval;
      localStorage.setItem("timeAndDepart", JSON.stringify(this.timeAndDepart));
    },
    depart_id(newval, oldVal) {
      this.timeAndDepart.changeDepart = newval;
      localStorage.setItem("timeAndDepart", JSON.stringify(this.timeAndDepart));
    }
  },
  methods: {
    //前一天
    beforetime() {
      this.sum = 1;
      const date = this.riqi;
      const ceshi = getNextDate(date, -1);
      this.riqi = ceshi;
      this.nowWeek = getweek(this.riqi);
      this.getTableData();
      this.getDaochu();
    },
    //后一天
    aftertime() {
      this.sum = 2;
      const date = this.riqi;
      const now = new Date();
      now.setTime(now.getTime() + 3600 * 1000 * 24 * 7);
      const nowwk = moment(now).format("YYYY-MM-DD");
      // console.log(date < nowtime);
      if (date < nowwk) {
        const ceshi = getNextDate(date, 1);
        this.riqi = ceshi;
        this.nowWeek = getweek(this.riqi);
        this.getTableData();
        this.getDaochu();
      }
    },
    getnowtime() {
      let timeAndDepart = JSON.parse(localStorage.getItem("timeAndDepart"));
      var hqtime = timeAndDepart.changeTime;
      //console.log(hqtime);
      if (typeof hqtime == "undefined") {
        let Time = moment(new Date()).format("YYYY-MM-DD");
        this.riqi = getNextDate(Time, 1);
      } else {
        this.riqi = hqtime;
      }
      this.nowWeek = getweek(this.riqi);
    },
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      //this.depart_id = uesrInfo.depart_ID;
      let timeAndDepart = JSON.parse(localStorage.getItem("timeAndDepart"));
      var hqdepart = timeAndDepart.changeDepart;
      if (typeof hqdepart == "undefined") {
        this.depart_id = uesrInfo.depart_ID; //初始id
      } else {
        this.depart_id = hqdepart;
        //console.log(hqdepart);
      }
      //console.log(this.depart_id);
    },
    tableRowClassName({ row, rowIndex }) {
      //console.log(row);
      if (row.colorTag === 1) {
        return "warning-row";
      } else if (row.colorTag === 2) {
        return "success-row";
      }
      return "";
    },
    getTableData() {
      getBaseInfo().then(data => {
        //console.log(this.depart_id);
        this.base_info = data;
        this.bumenList = data.depart_list;
        for (let key in this.bumenList) {
          if (key == this.depart_id) {
            this.bumenname = data.depart_list[this.depart_id].depart_name;
          }
        }
        axios
          .get(
            IPConfig.IP +
              "/kpi-management/info/daily_report_info.php?depart_id=" +
              this.depart_id +
              "&daily_report_date=" +
              this.riqi
          )
          .then(res => {
            showLoading();
            //console.log(res.data.errcode)
            if (0 == res.data.errcode) {
              //console.log(res.data.daily_report_list);

              this.tableData = [];
              let searchList = res.data.daily_report_list;
              var DataList = Object.values(searchList);
              //console.log(DataList);
              this.search(DataList);
            } else {
              console.log(res.data.errmsg);
            }
          });
      });
    },
    //搜索更新数据
    search(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        hideLoading();
        return;
      }
      //console.log(getDailyMsg);
      var tableList = [];
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }
        //获取人员
        for (let key in this.base_info.employee_all_list) {
          //console.log(key);
          if (vms.employee_id == key) {
            vms["rycn"] = this.base_info.employee_all_list[key].employee_name;
          }
        }
        let chioseList = gettaskOptions(vms.depart_id, this.base_info);
        vms["chioes"] = chioseList;
        //console.log(vms)

        vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
        var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
        var scopeName = [];
        Object.assign(scopeName, vms["value1"]);
        if (scopeName.length > 0) {
          vms["task_name_str"] = gettasklistStrName(
            vms.task_id,
            scopeName,
            taskoptions
          );
        }

        hourToMin(vms);
        tableList.push(vms);
        this.tableData = Object.values(tableList).sort(function(a, b) {
          return a.employee_id - b.employee_id;
        });
        // this.tableData.push(vms);
      }
      myGrounpX(this.tableData);
      hideLoading();
      //console.log(this.tableData);
    },
    gaibiandepart(el) {
      //console.log(el);
      for (let key in this.bumenList) {
        if (key == el) this.bumenname = this.bumenList[el].depart_name;
      }
      this.getTableData();
    },
    gaibianriqi(el) {
      this.nowWeek = getweek(this.riqi);
      this.getTableData();
      this.getDaochu();
    },
    getDaochu() {
      getBaseInfo().then(data => {
        //console.log(this.depart_id);
        this.base_info = data;
        //console.log(this.riqi);
        axios
          .get(
            IPConfig.IP +
              "/kpi-management/info/daily_report_info.php?daily_report_date=" +
              this.riqi
          )
          .then(res => {
            // showLoading();
            if (0 == res.data.errcode) {
              //console.log(res.data.daily_report_list);
              let searchList = res.data.daily_report_list;
              var DataList = Object.values(searchList);
              //console.log(DataList);
              this.searchAll(DataList);
            } else {
              console.log(res.data.errmsg);
            }
          });
      });
    },
    //导出的全部数据
    searchAll(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        hideLoading();
        return;
      }
      //console.log(getDailyMsg);
      var daochuList = [];
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }
        //获取人员
        for (let key in this.base_info.employee_all_list) {
          //console.log(key);
          if (vms.employee_id == key) {
            vms["rycn"] = this.base_info.employee_all_list[key].employee_name;
          }
        }
        let chioseList = gettaskOptions(vms.depart_id, this.base_info);
        vms["chioes"] = chioseList;
        //console.log(vms)

        vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
        var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
        var scopeName = [];
        Object.assign(scopeName, vms["value1"]);
        if (scopeName.length > 0) {
          vms["task_name_str"] = gettasklistStrName(
            vms.task_id,
            scopeName,
            taskoptions
          );
        }

        hourToMin(vms);
        daochuList.push(vms);
        this.daochuData = Object.values(daochuList).sort(function(a, b) {
          return a.employee_id - b.employee_id;
        });
        // this.tableData.push(vms);
      }
      // myGrounpX(this.daochuData);
      hideLoading();
      //console.log(this.daochuData);
    },
    // //生成excel表格
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportToExcel() {
      //console.log(this.daochuData);
      var printdailyworktable = [];
      printdailyworktable = this.getHeadername();

      //console.log(printdailyworktable);
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "日期",
          "姓名",
          "所属部门",
          "项目",
          "项目阶段",
          "工作时长",
          "工作内容"
        ];
        const filterVal = [
          "date",
          "name",
          "depart",
          "project",
          "phase_task",
          "work_hour",
          "comments"
        ];
        const list = printdailyworktable;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "工作列表_" + this.riqi);
      });
    },
    getHeadername() {
      //console.log(this.tableData);
      var printTabledata = [];
      var exceltablerowdata = {
        date: "",
        name: "",
        depart: "",
        project: "",
        phase_task: "",
        work_hour: "",
        comments: ""
      };

      //获取id对应的中文名称
      for (var i = 0; i < this.daochuData.length; i++) {
        let tablerowdata = Object.assign({}, exceltablerowdata);
        for (var key in this.base_info.project_list) {
          //console.log(key);
          if (this.daochuData[i].project_id == key) {
            tablerowdata.project = this.base_info.project_list[
              key
            ].project_name_cn;
          }
        }
        tablerowdata.depart = this.daochuData[i].bumencn;
        tablerowdata.phase_task = this.daochuData[i].task_name_str;
        tablerowdata.work_hour = this.daochuData[i].work_hour;
        tablerowdata.comments = this.daochuData[i].comments;
        tablerowdata.date = this.riqi;
        tablerowdata.name = this.daochuData[i].rycn;
        //console.log(tablerowdata);
        printTabledata.push(tablerowdata);
        tablerowdata = {};
      }
      // console.log(printTabledata);
      return printTabledata;
    }
  }
};
</script>
<style scoped>
/* 选中某行时的背景色*/
/* .el-table__body tr.current-row > td {
   background-color: #92cbf1 !important;
} */

/*鼠标移入某行时的背景色*/
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #92cbf1 !important;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/workplan/index.vue